import React, {memo} from "react";
import BaseModalSmall from "../BaseModalSmall";
import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeHandelModalAddPrice,
    actionChangeInputsModalAddPrice
} from "../../../../../redux/actions/modals/modalAddPrice";
import {handelOpenModalMyWallet} from "../../../../../redux/actions/modals/modalMyWallet";
import {BASE_URL, PAYMENT_CHARGE_WALLET} from "../../../../../apis";

const ModalAddPrice = () => {
    const dispatch = useDispatch();
    const {statusShow, price} = useSelector(state => state.modalAddPrice);
    const {token} = useSelector(state => state.user);

    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const handelPriceOnline = (event) => {
        event.preventDefault();
        // window.open(BASE_URL + PAYMENT_CHARGE_WALLET + `?amount=${price}&token=${token}`, "_self");
        window.open(BASE_URL + PAYMENT_CHARGE_WALLET + `?amount=${removeNonNumeric(price)}&token=${token}`, "_self");
        handleClose();
    };
    const handleClose = () => {
        dispatch(actionChangeHandelModalAddPrice(false));
    };

    const backToModal = () => {
        handleClose();
        dispatch(handelOpenModalMyWallet());
    };

    const handelChangeInputsModalAddPrice = (event) => {
        const {name, value} = event.target;

        // dispatch(actionChangeInputsModalAddPrice(name, value));
        // const amountString = new Intl.NumberFormat().format(parseFloat(value));
        dispatch(actionChangeInputsModalAddPrice(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    return (
        <BaseModalSmall title={'افزایش اعتبار'}
                        show={statusShow}
                        dialogClassName={''}
                        handleClose={handleClose}>
            <Modal.Body>
                <Form onSubmit={handelPriceOnline}>

                    <Form.Group controlId="input-form-add-price">
                        <Form.Label>
                            لطفا مبلغ را به تومان وارد کنید
                        </Form.Label>
                        <Form.Control type="text" name={'price'} className={'text-center'}
                                      value={price} onChange={handelChangeInputsModalAddPrice}
                                      placeholder="مبلغ افزایش اعتبار"
                                      pattern="\d*"/>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Row className={'w-100'}>
                    <Col xs={6}>
                        <Button variant="success" className={'base-btn-green btn-sm'} onClick={handelPriceOnline} block>
                            پرداخت آنلاین
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button variant="success" className={'base-btn-green-border btn-sm'} block onClick={backToModal}>
                            بازگشت
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </BaseModalSmall>
    );
};

export default memo(ModalAddPrice);
